import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { ApplicationField } from 'embed/components/ApplicationField/container'

import { StepTitle } from 'embed/components/Application/StepTitle'
import Wrapper from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  onBack: () => void
  onContinue: () => void
  onEnter?: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

const StepbystepApplicationStepName: React.SFC<Props> = (props) => (
  <Wrapper {...props}>
    <StepTitle>What’s your name?</StepTitle>
    <ApplicationField product={Product.Loan} field={Fields.FirstName} onEnter={props.onEnter} />
    <ApplicationField product={Product.Loan} field={Fields.LastName} onEnter={props.onEnter} />
  </Wrapper>
)

export default StepbystepApplicationStepName
